import type { SVGProps } from 'react';

export const UnfoldMore = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m12 18.475 2.55-2.55a.72.72 0 0 1 .525-.225.64.64 0 0 1 .55.225.71.71 0 0 1 .25.55c0 .2-.083.375-.25.525l-3 3a.6.6 0 0 1-.3.2c-.1.033-.208.05-.325.05a1.27 1.27 0 0 1-.35-.05.615.615 0 0 1-.275-.2l-3-3a.82.82 0 0 1-.25-.525c0-.217.083-.4.25-.55a.687.687 0 0 1 .525-.25c.217 0 .4.083.55.25l2.55 2.55ZM12 5.6 9.45 8.15a.748.748 0 0 1-.55.225.72.72 0 0 1-.525-.225c-.167-.167-.25-.35-.25-.55 0-.2.083-.383.25-.55l3-3a.702.702 0 0 1 .275-.175A.882.882 0 0 1 12 3.8c.117 0 .225.025.325.075a.681.681 0 0 1 .3.175l3 3c.15.15.225.333.225.55.017.2-.058.383-.225.55a.748.748 0 0 1-.55.225.72.72 0 0 1-.525-.225L12 5.6Z" />
    </svg>
  );
};
